export default __webpack_public_path__ + "static/media/wf.311c4e73.svg";